module.exports = __webpack_public_path__ + "static/media/facebook-footer.a6be0ca7.svg";